<template>
<div class="card">
    <div class="card-header">Posted</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>
        <BaseStatusHelp lifecycleStatus="08"/>

        <b-form @submit.stop.prevent="onSubmit">
            <b-row>
                <b-col>
                    <LifecycleCheckList lifecycleStatus="08" :requestId="request.id"
                        v-on:checklist-update="updateChecklistStatus($event)" ref="checklist"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12" lg="6">
                    <BaseDateInput v-model="request.postingOpenDate" 
                        :v="$v.request.postingOpenDate"
                        label="Posting Open Date"
                        slug="open-date"/>
                </b-col>
                <b-col cols="12" lg="6">
                    <BaseDateInput v-model="request.postingCloseDate" 
                        :v="$v.request.postingCloseDate"
                        label="Posting Close Date"
                        slug="close-date"/>                        
                </b-col>
            </b-row>

            <b-row style="margin-bottom:20px;">
                <b-col cols="12" lg="6">
                  <BaseSelector v-model="request.howPosted"
                                :v="$v.request.howPosted"
                                label="How Posted"
                                slug="how-posted"
                                :options=howPostedOptions />
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <BaseParagraphInput v-model="request.postingComments"
                        :v="$v.request.postingComments" 
                        slug="postingComments"
                        label="Internal Comments"/>
                </b-col>
            </b-row>
            
            <div>
            <b-button type="submit" variant="warning">Complete Posting Now</b-button>
            <b-button type="button" variant="outline-primary" @click="save">Save</b-button>
            <b-button type="button" variant="outline-primary" @click="repost">Repost Position</b-button>
            </div>
        </b-form>
    </div>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredUnless } from 'vuelidate/lib/validators'
import LifecycleCheckList from '@/components/lifecycles/LifecycleCheckList'
import _ from "lodash"
import {commonOptions} from "@/mixins/commonOptions";

export default {
    components: {
        LifecycleCheckList,
    },
    props: {
        request: Object
    },
  mixins: [
    commonOptions
  ],
  data() {
        return {
            checklistComplete: false,
            saveOnly: false,
          howPostedOptions:[
            { value: 'Statewide', text: 'Statewide' },
            { value: 'Competitive', text: 'Competitive' },
            { value: 'Agency Only', text: 'Agency Only' },
            { value: 'Non-Competitive', text: 'Non-Competitive' },
          ]
        }
    },
    validations() {
        return {
         checklistComplete: { checked: value => value === true },
         request: {  
             postingComments: { required: false, maxLength: maxLength(4000)},  
             postingOpenDate: { 
                 required: requiredUnless(function() {
                    return _.includes(['06'], this.request.requestTypeValue.code)
                }),
              },
             postingCloseDate: {
                required: requiredUnless(function() {
                    return _.includes(['06'], this.request.requestTypeValue.code)
                }),
            },
            howPosted:{required: false},
        }
       } 
    },
    
    mounted: function() {
        this.autosave()
    },
    
    beforeDestroy() {
       clearInterval(this.autosave_id)
    },
        
    methods: {
        updateChecklistStatus(b) {
            this.checklistComplete = b
        },

        autosave() {          
            this.autosave_id = setInterval(() => {
                this.save()
            }, 300000);
        },

        save() {
            this.saveOnly = true
            this.onSubmit()
            this.saveOnly = false
        },

        repost() {
            let payload = {
                id: this.request.id,
                transitionStatusTo: '07'
            }
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/transition`, payload)
                .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    this.$router.push('/home') 
                }) 
        },

        onSubmit() {
            if (!this.saveOnly) {
                this.$refs.checklist.emitCheckListStatus()
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$nextTick(() => {
                        document.getElementById('form-container').scrollIntoView()
                    })
                    return
                }
            }

            let payload = {
                requestId: this.request.id,
                comments: this.request.postingComments, 
                postingOpenDate: this.request.postingOpenDate,
                postingCloseDate: this.request.postingCloseDate,
                howPosted: this.request.howPosted,
                advanceNextLifecycle: !this.saveOnly,
                nextLifecycle: '09'
            }

            axios.post(`${process.env.VUE_APP_API_BASE_URL}/request/posted`, payload)
                  .then(response => { 
                    this.showRootToast("HRM Request Has Been Updated", "Success", "success")
                    if (payload.advanceNextLifecycle === true) {
                        this.$router.push('/home')
                    } 
                  })         
        },
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
    }   
}
</script>